/* Searchable dropdown used by the tool pages. SKCombo.html(id, label, placeholder) returns the markup;
   SKCombo.init(root, id, items, start) wires it. items = [{ label, group, v }] (group and v optional, v defaults to the position, items of one group should be adjacent).
   The chosen item's v is kept in the hidden input #<id>. Type to filter, arrows + Enter, Esc to close. */
(function () {
  'use strict';
  function html(id, label, placeholder) {
    return '<div class="tl-field"><label for="' + id + '-q">' + label + '</label><div class="tl-combo" id="' + id + '-combo">' +
      '<input type="search" id="' + id + '-q" role="combobox" aria-expanded="false" aria-controls="' + id + '-list" aria-autocomplete="list" autocomplete="off" placeholder="' + placeholder + '">' +
      '<input type="hidden" id="' + id + '" value="0"><ul class="tl-combo__list" id="' + id + '-list" role="listbox" hidden></ul></div></div>';
  }
  function init(root, id, items, start) {
    var inp = root.querySelector('#' + id + '-q'), hid = root.querySelector('#' + id), list = root.querySelector('#' + id + '-list');
    var shown = [], active = -1;
    function val(i) { return items[i].v != null ? items[i].v : i; }
    function pos() { for (var k = 0; k < items.length; k++) if (String(val(k)) === String(hid.value)) return k; return 0; }
    function close() { list.hidden = true; inp.setAttribute('aria-expanded', 'false'); active = -1; }
    function choose(i) { hid.value = val(i); inp.value = items[i].label; close(); }
    function mark() {
      [].forEach.call(list.children, function (li) { li.classList.toggle('is-active', +li.getAttribute('data-i') === shown[active]); });
      var on = list.querySelector('.is-active'); if (on && on.scrollIntoView) on.scrollIntoView({ block: 'nearest' });
    }
    function open(term) {
      term = (term || '').trim().toLowerCase();
      shown = []; var out = '', grp = null;
      items.forEach(function (it, i) {
        if (term && it.label.toLowerCase().indexOf(term) < 0) return;
        if (it.group && it.group !== grp) { grp = it.group; out += '<li class="tl-combo__grp" role="presentation">' + grp + '</li>'; }
        shown.push(i); out += '<li role="option" data-i="' + i + '">' + it.label + '</li>';
      });
      list.innerHTML = out || '<li class="tl-combo__none" role="presentation">Nothing found. Try another word.</li>';
      list.hidden = false; inp.setAttribute('aria-expanded', 'true'); active = -1;
    }
    inp.addEventListener('focus', function () { inp.select(); open(''); });
    inp.addEventListener('input', function () { open(inp.value); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (list.hidden) open(inp.value);
        if (shown.length) { active = (active + (e.key === 'ArrowDown' ? 1 : -1) + shown.length) % shown.length; mark(); }
      } else if (e.key === 'Enter') {
        if (!list.hidden) { e.preventDefault(); if (active < 0 && shown.length) active = 0; if (active >= 0) choose(shown[active]); }
      } else if (e.key === 'Escape') { close(); inp.value = items[pos()].label; }
    });
    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest ? e.target.closest('li[data-i]') : null;
      if (li) { e.preventDefault(); choose(+li.getAttribute('data-i')); }
    });
    inp.addEventListener('blur', function () { close(); inp.value = items[pos()].label; });
    hid.value = val(start || 0); inp.value = items[pos()].label;
  }
  window.SKCombo = { html: html, init: init };
})();
